var map = {
	"./Kazang.png": 7136,
	"./classic.jpg": 7732,
	"./credit.png": 4650,
	"./eftpay.png": 8009,
	"./icons/dpo_logo.svg": 2523,
	"./icons/flags-in-table.jpg": 7577,
	"./icons/rotate-ccw.svg": 2421,
	"./logo.png": 6949,
	"./pdf.png": 475,
	"./styles/_animations.css": 2618,
	"./styles/_variables.css": 1486,
	"./styles/main.css": 3405,
	"./success.png": 8296
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7173;